import React, { useEffect } from "react"

import { Link } from "gatsby"

import { categoryClasses } from "../utils/category-classes"
import CtaSection from "../components/Sections/CtaSection"
import QuoteForm from "../components/Common/QuoteForm"
import SEO from "@ifp/gatsby-theme-shared/src/components/SEO/seo"

const faqTypes = [
    {
        title: "Individuals & Families",
        url: "individual-and-family-faq",
        stylingMap: "individual-and-family",
        excerpt: `Find all the information you need to know about individual health insurance and family health plans from eHealth.`,
    },
    {
        title: "Affordable Care Act",
        url: "affordable-care-act-faq",
        stylingMap: "affordable-care-act",
        excerpt: `Learn more about Obamacare plans, information about the Affordable Care Act, and how it affects you and those you cover.`,
    },
    {
        title: "Dental",
        url: "dental-faq",
        stylingMap: "dental-insurance",
        excerpt: `Explore information about dental coverage and get more information on how to find an affordable dental plan.`,
    },
    {
        title: "Life Insurance",
        url: "life-insurance-faq",
        stylingMap: "short-term",
        excerpt: `Life insurance policies can be confusing—find all the resources you need to understand whether or not this coverage is right for you.`,
    },
    {
        title: "Student Health Insurance",
        url: "student-health-insurance-faq",
        stylingMap: "vision-insurance",
        excerpt: `All the resources students need to navigate the world of health insurance while they’re pursuing an education.`,
    },
]

export default () => {
    useEffect(() => {
        window._waEvents.push("pageView", {
            page: {
                section: "frequently-asked-questions",
                name: "page:frequently-asked-questions",
                language: "english",
            },
            sysEnv: {
                siteGroup: "rc",
            },
        })
    })

    return (
        <>
            <SEO
                title="Frequently Asked Questions - eHealth Insurance"
                excerpt="Find the most asked questions our health insurance experts get everyday. Your crash course is here."
                slug="frequently-asked-questions/"
                pageType="resources"
            />
            <div className="ehi-header--spacer"></div>
            <section>
                <div className="container">
                    <div className="row section-title justify-content-center text-center">
                        <div
                            className="col-md-9 col-lg-8 col-xl-7"
                            style={{
                                opacity: 0,
                                animation:
                                    "scaleDown 1s cubic-bezier(0.215,0.61,0.355,1) forwards",
                            }}
                        >
                            <h1 className="display-3">
                                Frequently Asked Questions
                            </h1>
                            <div className="lead">
                                Find the most asked questions our health
                                insurance experts get everyday. Your crash
                                course is here.
                            </div>
                        </div>
                    </div>
                    <div
                        className="row justify-content-center"
                        style={{
                            opacity: 0,
                            animation:
                                "fadeUpSubtle 1s cubic-bezier(0.215,0.61,0.355,1) forwards",
                        }}
                    >
                        {faqTypes.map((faq, index) => {
                            return (
                                <div
                                    key={index}
                                    className="col-md-6 mb-3 mb-md-4"
                                >
                                    <div
                                        className={`card card-body min-vh-md-30 hover-box-shadow ${
                                            categoryClasses[faq.stylingMap]
                                        }`}
                                    >
                                        <div className="flex-fill">
                                            <h2 className="font-weight-bolder">
                                                {faq.title}
                                            </h2>
                                            <p>{faq.excerpt}</p>
                                        </div>
                                        <Link
                                            to={`/${faq.url}`}
                                            className="stretched-link"
                                        >
                                            Learn More
                                        </Link>
                                    </div>
                                </div>
                            )
                        })}
                    </div>
                </div>
            </section>
            <CtaSection
                useTopDivider={true}
                headline="Find the perfect health plan."
            >
                <div className="d-flex flex-column flex-lg-row justify-content-center align-items-center mt-4 mt-lg-0">
                    <QuoteForm
                        fromPage="/resources/frequently-asked-questions"
                        censusPage="Individual and Family"
                    />
                    {/* <div className="mb-4 m-lg-5">Or</div>
                    <button className="button-secondary">
                        Speak with a Representative
                    </button> */}
                </div>
            </CtaSection>
        </>
    )
}
